import React, { useRef, useState } from "react";

// third-party
import moment from "moment";
import { Modal } from "react-bootstrap";
import generatePDF, { Resolution, Margin, DetailedMargin } from "react-to-pdf";

// project-import
import { PAISE } from "../../constants/entityType";
import Image from "../../common/footer/Images/Image";
import { formatCurrency, handleDiscountPrice } from "../../utils/course";
import { GoogleAnalyticsEnum, pageView } from "../../utils/google-analytics";
import OrderDetailHeader from "./OrderDetailHeader";
import Spinner from '../spinner-component/SpinnerOne';

export const OrderDetails = ({ show, onCloseModal, title = "Form", data, isOrderFree }) => {

    const orderRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);

    const rawPaymentDetails = data && data?.payments && data?.payments?.length && data?.payments[0]?.raw ? JSON.parse(data?.payments && data?.payments.length && data?.payments[0]?.raw) : {};
    const orderAmount = data && data?.amount > 0 ? (data?.amountUnit === PAISE ? (data?.amount / 100) : data?.amount) : 0.00;
    const orderCurrency = data && data?.orderCurrency && data?.orderCurrency === "INR" ? "₹" : "$";
    const amountPaid = data && data?.amountPaid > 0 ? (data?.amountUnit === PAISE ? (data?.amountPaid / 100) : data?.amountPaid) : 0.00;
    const amountDue = data && data?.amount > 0 ? (data?.amountUnit === PAISE ? (data?.amountDue / 100) : data?.amountDue) : "Free";
    const orderCreateDate = data && moment(data?.createdAt).format("ll");
    const orderCreateTime = data && moment(data?.createdAt).format("LT");
    const paidDateTime = data && data?.payments && data?.payments.length ? data?.payments[0]?.createdAt : "Not Available";
    const paymentData = data && data?.payments && data?.payments.length > 0 ? data?.payments[0] : {};
    const orderNote = data && data?.notes && data?.notes?.length ? data?.notes[0] : {};
    const productType = orderNote && orderNote?.type && orderNote?.type === "ebook" ? "ebooks" : "offerings";
    const orderDiscount = orderNote && orderNote?.discountPercent > 0 ? orderNote?.discountPercent : 0;
    const formattedCreateDate = data && data?.createdAt && moment(data?.createdAt).format("MMM D, YYYY [at] hh:mm a");
    const formattedOrderSummary = orderNote ? orderNote?.category + " " + orderNote?.subCategory + " " + orderNote?.type : "";

    // TODO: 01082025 - Handle the amount in the discount scenario
    let orderPrice = (orderNote?.price || 0);
    // console.log("34=>orderNote", orderNote);

    if (orderPrice && orderPrice > 0 && orderDiscount && orderDiscount > 0) {
        // using this formula to get this original order price
        orderPrice = (orderPrice / 100) / (1 - (orderDiscount / 100));

        // console.log("40=>orderPrice", orderPrice);
        // Set the original price on the order node
        if (orderNote && orderPrice && !orderNote.isPriceAdjusted) {
            orderNote.isPriceAdjusted = true;
            orderNote.price = orderPrice * 100;
            // console.log("44=>orderNote", orderNote);
        }
    }

    const options = {
        // default is `save`
        // method: "open",
        filename: data?.razorPayOrderId + "_Longswitch_Academy.pdf",
        resolution: Resolution.HIGH,
        page: {
            // margin: { top: 0, right: Margin.MEDIUM, bottom: 20, left: Margin.MEDIUM },
            margin: Margin.MEDIUM
        }
    };

    // TODO: 01082025 Added fix for the mobile generate issue
    const generateFullPagePDF = async () => {
        try {
            if (!orderRef.current) {
                console.error("Target element not found");
                return;
            }

            await generatePDF(orderRef, {
                filename: options?.filename || "longswitch-academy-order.pdf",
                page: { format: "A4", orientation: "portrait" },
                resolution: options?.resolution,
                canvas: {
                    useCORS: true,
                    allowTaint: false,
                },
            });

        } catch (error) {
            console.log("PDF Error:", error?.message || error);
        }

    };

    return (
        <div>
            <Modal
                className="rounded-lg"
                show={show}
                onHide={onCloseModal}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                size="xl"
            >
                {pageView(window.location.pathname, GoogleAnalyticsEnum.SF_ORDER_DETAIL_MODAL_VIEW)}
                <Modal.Header closeButton className="px-5 pb-0">
                    <Modal.Title as="h5" className="mb-0">{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="px-4 pb-4">
                    {isLoading && <Spinner />}
                    <div className="row gx-3 gy-2" id="order-detail-content">
                        <div className="col-12">
                            <OrderDetailHeader
                                title="My Orders"
                                rootUrl="/"
                                parentUrl="Home"
                                googleEnum={GoogleAnalyticsEnum.CONTACT_US_TO_HOME}
                                currentUrl="My Orders"
                            />
                            <h6 className="m-0 px-3 justify-content-center">Order ID : {data?.razorPayOrderId} <span class="fs-5 badge text-success rounded-pill bg-success bg-opacity-25 text-capitalize">{isOrderFree ? "Free" : data?.status === "authorized" ? "paid" : data?.status}</span></h6>
                            {/* <p className="m-0 mb-3 px-3 fs-4 fw-bold"><span className="text-capitalize">{data?.status} </span>{moment(data?.createdAt).format("MMM D, YYYY [at] hh:mm a")}</p> */}
                            <p className="m-0 mb-3 px-3 fs-4 fw-bold">Placed on {formattedCreateDate}</p>
                        </div>

                        <div className="col-12 col-lg-8">
                            <div className="row g-3 px-3">
                                <div className="col-12 border border-1 rounded-3 p-3">
                                    <h6 className="fs-3 mb-2">Ordered Item(s) ({data?.notes?.length || 0})</h6>
                                    <ul class="list-group list-group-flush">
                                        {(data?.notes || [])?.map((item) => (
                                            <li class="list-group-item">
                                                <div className="row">
                                                    <div className="col-4 col-sm-1">
                                                        <Image className="ratio ratio-1x1" src={`${process.env.PUBLIC_URL}/images/${productType}/${data?.notes && data?.notes.length && data?.notes[0]?.thumbnailUrl}`} alt="Event Thumb" />
                                                    </div>
                                                    <div className="col-8 col-sm-6">

                                                        <div className="row">
                                                            <div className="col-12"><p className="fs-5 mb-0">{item?.productCode}</p></div>
                                                            <div className="col-12"><span className="fw-bold fs-4">{item?.name}</span></div>
                                                            <div className="col-12 m-0"><p className="fs-5 fw-bold m-0 text-capitalize"> {formattedOrderSummary}</p></div>
                                                        </div>
                                                    </div>
                                                    <div className="col-6 col-sm-2"><span className="fs-4 m-0">1 item</span></div>
                                                    <div className="col-6 col-sm-3 text-end"><span className="fs-4 m-0 text-capitalize"> {isOrderFree ? "0" : formatCurrency((item?.price) / 100)}</span></div>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="col-12 border border-1 rounded-3 p-3">
                                    <div className="row">
                                        <div className="col-12"><h6 className="fs-3 mb-2">Order Summary</h6></div>
                                        <div className="col-12 py-2">
                                            <div className="row">
                                                <div className="col-5 col-sm-4">Subtotal</div>
                                                <div className="col-7 col-sm-4 text-end sm:text-center">{data?.notes?.length > 1 ? (data?.notes?.length + " items") : (data?.notes?.length + " item")}</div>
                                                <div className="col-12 col-sm-4 text-end">{isOrderFree ? "₹ 0" : formatCurrency((orderNote?.price) / 100)}</div>
                                            </div>
                                            <div className="row">
                                                <div className="col-5 col-sm-4">Discount</div>
                                                <div className="col-7 col-sm-4 text-end sm:text-center">{orderDiscount} %</div>
                                                <div className="col-12 col-sm-4 text-end">- {handleDiscountPrice(data)?.formattedAmount}</div>
                                            </div>
                                            <div className="row pt-2 align-content-end justify-content-sm-end">
                                                <div className="col-12 col-sm-6 fw-bold">
                                                    <div className="row text-sm-center bg-primary-color text-white">
                                                        <div className="col-6 fw-bold fs-1">
                                                            Total
                                                        </div>
                                                        <div className="col-6 fw-bold text-end">
                                                            <p className={`m-0 text-white fs-1`}>{isOrderFree ? "Free" : handleDiscountPrice(data)?.discountedAmount}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {paymentData && paymentData?.paymentId &&
                                    <div className="col-12 border border-1 rounded-3 p-3">
                                        <div className="row">
                                            <div className="col-12">
                                                <p className="m-0 has-primary-text fs-1">Thank You for your purchase!</p>
                                            </div>
                                            <div className="col-12 col-md-5 col-lg-3 align-content-center">
                                                <p className="text-break m-0 d-flex"><i class="ri-phone-line px-1"></i><span>{process.env.REACT_APP_OFFICIAL_PHONE_NUMBER}</span></p>
                                            </div>
                                            <div className="col-12 col-md-7 col-lg-9 align-content-center">
                                                <p className="text-break m-0 d-flex"><i class="ri-mail-line px-1"></i><span>{process.env.REACT_APP_OFFICIAL_EMAIL_ADDRESS}</span></p>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-12 gy-3">
                                                <h6 className="m-0 justify-content-center">Terms & Conditions</h6>
                                            </div>
                                            <div className="col-12">
                                                We have no return, no refund policy.
                                            </div>
                                        </div>
                                    </div>}
                            </div>
                        </div>

                        <div className="col-12 col-lg-4 border border-1 rounded-3">
                            <div className="row gx-1 px-3 align-items-center">
                                <div className="col-12 border-bottom fs-4 p-3">
                                    <h6 className="mb-1 fs-3">Customer Info</h6>
                                    <ul className="list-unstyled mb-2">
                                        <li className="m-0"><i className="icon-user-line px-1"></i>{data?.customer?.fullName}</li>
                                        <li className="m-0"><i className="icon-mail-line-2 px-1"></i>{data?.customer?.email}</li>
                                    </ul>
                                </div>
                                <hr />
                                <div className="col-12 border-bottom fs-4 p-3">
                                    <h6 className="mb-1 fs-3">Vendor Info</h6>
                                    <ul className="list-unstyled mb-2">
                                        {data?.vendorName ? <li className="m-0"><i className="icon-user-line px-1"></i>{data?.vendorName}</li> : <li>Not Available</li>}
                                    </ul>
                                </div>
                                <hr />
                                {!isOrderFree &&
                                    <div className="col-12 fs-4 p-3 pt-0">
                                        <h6 className="mb-1 fs-3">Payment Details</h6>
                                        <ul className="list-unstyled mb-0">
                                            {paymentData && paymentData?.paymentId
                                                ? <>
                                                    <li className="m-0">Payment ID : {paymentData?.paymentId}</li>
                                                    <li className="m-0">Currency : {paymentData?.paymentCurrency}</li>
                                                    <li className="m-0">Method : {paymentData?.method}</li>
                                                    <li className="m-0">Email : {paymentData?.email}</li>
                                                    <li className="m-0">Contact : {paymentData?.contact}</li>
                                                    <li className="m-0">Amount : {paymentData?.amount ? formatCurrency(paymentData?.amount) : 0.00}</li>
                                                    <li className="m-0 text-capitalize">Status : {data?.payments && data?.payments.length && data?.payments[0]?.status}</li>
                                                    <li className="m-0">VPA : {rawPaymentDetails?.vpa}</li>
                                                    <li className="m-0">Account Type : {rawPaymentDetails?.upi?.payer_account_type}</li>
                                                    <li className="m-0">Paid at : {paidDateTime}</li>
                                                    {/* <li className="m-0">Flow : {rawPaymentDetails?.upi?.flow}</li> */}
                                                </>
                                                :
                                                <li className="m-0">Not Available</li>
                                            }
                                        </ul>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                    {/* Used for printing */}
                    <div className="row gx-3 gy-2" id="order-detail-content-print" ref={orderRef} style={{
                        position: "fixed",
                        top: "-10000px",
                        left: "-10000px",
                        width: `${1084}px`,
                        minHeight: "1123px",
                        background: "#fff",
                        padding: "24px",
                        boxSizing: "border-box",
                    }}>
                        <div className="col-12">
                            <OrderDetailHeader
                                title="My Orders"
                                rootUrl="/"
                                parentUrl="Home"
                                googleEnum={GoogleAnalyticsEnum.CONTACT_US_TO_HOME}
                                currentUrl="My Orders"
                            />
                            <h6 className="m-0 px-3 justify-content-center">Order ID : {data?.razorPayOrderId} <span class="fs-5 badge text-success rounded-pill bg-success bg-opacity-25 text-capitalize">{isOrderFree ? "Free" : data?.status === "authorized" ? "paid" : data?.status}</span></h6>
                            {/* <p className="m-0 mb-3 px-3 fs-4 fw-bold"><span className="text-capitalize">{data?.status} </span>{moment(data?.createdAt).format("MMM D, YYYY [at] hh:mm a")}</p> */}
                            <p className="m-0 mb-3 px-3 fs-4 fw-bold">Placed on {formattedCreateDate}</p>
                        </div>

                        <div className="col-12 col-lg-8">
                            <div className="row g-3 px-3">
                                <div className="col-12 border border-1 rounded-3 p-3">
                                    <h6 className="fs-3 mb-2">Ordered Item(s) ({data?.notes?.length || 0})</h6>
                                    <ul class="list-group list-group-flush">
                                        {(data?.notes || [])?.map((item) => (
                                            <li class="list-group-item">
                                                <div className="row">
                                                    <div className="col-4 col-sm-1">
                                                        <img className="ratio ratio-1x1" src={`${process.env.PUBLIC_URL}/images/${productType}/${data?.notes && data?.notes.length && data?.notes[0]?.thumbnailUrl}`} alt="Order Item Thumbnail" />
                                                    </div>
                                                    <div className="col-8 col-sm-6">

                                                        <div className="row">
                                                            <div className="col-12"><p className="fs-5 mb-0">{item?.productCode}</p></div>
                                                            <div className="col-12"><span className="fw-bold fs-4">{item?.name}</span></div>
                                                            <div className="col-12 m-0"><p className="fs-5 fw-bold m-0 text-capitalize"> {formattedOrderSummary}</p></div>
                                                        </div>
                                                    </div>
                                                    <div className="col-6 col-sm-2"><span className="fs-4 m-0">1 item</span></div>
                                                    <div className="col-6 col-sm-3 text-end"><span className="fs-4 m-0 text-capitalize"> {isOrderFree ? "0" : formatCurrency((item?.price) / 100)}</span></div>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="col-12 border border-1 rounded-3 p-3">
                                    <div className="row">
                                        <div className="col-12"><h6 className="fs-3 mb-2">Order Summary</h6></div>
                                        <div className="col-12 py-2">
                                            <div className="row">
                                                <div className="col-5 col-sm-4">Subtotal</div>
                                                <div className="col-7 col-sm-4 text-end sm:text-center">{data?.notes?.length > 1 ? (data?.notes?.length + " items") : (data?.notes?.length + " item")}</div>
                                                <div className="col-12 col-sm-4 text-end">{isOrderFree ? "₹ 0" : formatCurrency((orderNote?.price) / 100)}</div>
                                            </div>
                                            <div className="row">
                                                <div className="col-5 col-sm-4">Discount</div>
                                                <div className="col-7 col-sm-4 text-end sm:text-center">{orderDiscount} %</div>
                                                <div className="col-12 col-sm-4 text-end">- {handleDiscountPrice(data)?.formattedAmount}</div>
                                            </div>
                                            <div className="row pt-2 align-content-end justify-content-sm-end">
                                                <div className="col-12 col-sm-6 fw-bold">
                                                    <div className="row text-sm-center bg-primary-color text-white">
                                                        <div className="col-6 fw-bold fs-1">
                                                            Total
                                                        </div>
                                                        <div className="col-6 fw-bold text-end">
                                                            <p className={`m-0 text-white fs-1`}>{isOrderFree ? "Free" : handleDiscountPrice(data)?.discountedAmount}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {paymentData && paymentData?.paymentId &&
                                    <div className="col-12 border border-1 rounded-3 p-3">
                                        <div className="row">
                                            <div className="col-12">
                                                <p className="m-0 has-primary-text fs-1">Thank You for your purchase!</p>
                                            </div>
                                            <div className="col-12 col-md-5 col-lg-3 align-content-center">
                                                <p className="text-break m-0 d-flex"><i class="ri-phone-line px-1"></i><span>{process.env.REACT_APP_OFFICIAL_PHONE_NUMBER}</span></p>
                                            </div>
                                            <div className="col-12 col-md-7 col-lg-9 align-content-center">
                                                <p className="text-break m-0 d-flex"><i class="ri-mail-line px-1"></i><span>{process.env.REACT_APP_OFFICIAL_EMAIL_ADDRESS}</span></p>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-12 gy-3">
                                                <h6 className="m-0 justify-content-center">Terms & Conditions</h6>
                                            </div>
                                            <div className="col-12">
                                                We have no return, no refund policy.
                                            </div>
                                        </div>
                                    </div>}
                            </div>
                        </div>

                        <div className="col-12 col-lg-4 border border-1 rounded-3">
                            <div className="row gx-1 px-3 align-items-center">
                                <div className="col-12 border-bottom fs-4 p-3">
                                    <h6 className="mb-1 fs-3">Customer Info</h6>
                                    <ul className="list-unstyled mb-2">
                                        <li className="m-0"><i className="icon-user-line px-1"></i>{data?.customer?.fullName}</li>
                                        <li className="m-0"><i className="icon-mail-line-2 px-1"></i>{data?.customer?.email}</li>
                                    </ul>
                                </div>
                                <hr />
                                <div className="col-12 border-bottom fs-4 p-3">
                                    <h6 className="mb-1 fs-3">Vendor Info</h6>
                                    <ul className="list-unstyled mb-2">
                                        {data?.vendorName ? <li className="m-0"><i className="icon-user-line px-1"></i>{data?.vendorName}</li> : <li>Not Available</li>}
                                    </ul>
                                </div>
                                <hr />
                                {!isOrderFree &&
                                    <div className="col-12 fs-4 p-3 pt-0">
                                        <h6 className="mb-1 fs-3">Payment Details</h6>
                                        <ul className="list-unstyled mb-0">
                                            {paymentData && paymentData?.paymentId
                                                ? <>
                                                    <li className="m-0">Payment ID : {paymentData?.paymentId}</li>
                                                    <li className="m-0">Currency : {paymentData?.paymentCurrency}</li>
                                                    <li className="m-0">Method : {paymentData?.method}</li>
                                                    <li className="m-0">Email : {paymentData?.email}</li>
                                                    <li className="m-0">Contact : {paymentData?.contact}</li>
                                                    <li className="m-0">Amount : {paymentData?.amount ? formatCurrency(paymentData?.amount) : 0.00}</li>
                                                    <li className="m-0 text-capitalize">Status : {data?.payments && data?.payments.length && data?.payments[0]?.status}</li>
                                                    <li className="m-0">VPA : {rawPaymentDetails?.vpa}</li>
                                                    <li className="m-0">Account Type : {rawPaymentDetails?.upi?.payer_account_type}</li>
                                                    <li className="m-0">Paid at : {paidDateTime}</li>
                                                    {/* <li className="m-0">Flow : {rawPaymentDetails?.upi?.flow}</li> */}
                                                </>
                                                :
                                                <li className="m-0">Not Available</li>
                                            }
                                        </ul>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                    <div className="row gx-3">
                        <div className="col-12 text-end mt-3">
                            {paymentData && paymentData?.paymentId && <button className="edu-btn btn-small subscribe mx-3" onClick={generateFullPagePDF}>Download Invoice</button>}
                            <button className="edu-btn btn-small btn-border-primary" onClick={onCloseModal}>Okay</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}
